import { Button as DubButton, ButtonProps as DubButtonProps } from "@dub/ui";
import { forwardRef } from "react";

export const Button = forwardRef<HTMLButtonElement, DubButtonProps>((props, ref) => {
  const { className, ...rest } = props;
  // Enforce w-auto by default, but allow overrides via className
  return <DubButton ref={ref} className={`w-auto ${className || ""}`} {...rest} />;
});

export type { DubButtonProps as ButtonProps };


